import { render, staticRenderFns } from "./movimentacao.vue?vue&type=template&id=3e577d56&"
import script from "./movimentacao.vue?vue&type=script&lang=js&"
export * from "./movimentacao.vue?vue&type=script&lang=js&"
import style0 from "./movimentacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports